// JavaScript code for acf_blocks/membership component
(($) => {

     "use strict";
     console.log("acf_blocks/membership scripts loaded...");

})(jQuery);